import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { Form as ToolkitForm, Grid, FlexBaseCol, FlexRow, Icon } from '@contently/toolkit';
import styled from '@emotion/styled';

import useLocalStorage from '../utils/hooks/useLocalStorage';
import InputField from './InputField';
import SelectField from './SelectField';
import HiddenField from './HiddenField';
import validation, { isRequired, isPhoneNumber } from '../utils/validation';

const AdditionalInfoForm = ({ onInfoFormSubmit }) => {
  const [values, setValues] = useLocalStorage('formValues', {});
  const directCustomer = useLocalStorage('directCustomer', false)[0];

  const teamSizes = [
    { value: 'Just me', label: 'Just me' },
    { value: '1-5 people', label: '1-5 people' },
    { value: '5-10 people', label: '5-10 people' },
    { value: '< 10 people', label: '< 10 people' }
  ];
  const contentPriorities = [
    { value: 'Grow our content program', label: 'Grow our content program' },
    { value: 'Improve our content quality', label: 'Improve our content quality' },
    { value: 'Other', label: 'Other' }
  ];

  const StyledButtonCol = styled(FlexBaseCol)`
    text-align: center;
  `;

  const StyledButton = styled(ToolkitForm.Button)`
    border: 0;
    text-transform: none;
    background: #e8f7fa;
    ${Icon} {
      font-size: 1.25rem;
      margin-left: 0.5em;
    }
  `;

  const StyledDisabledField = styled(InputField)`
    &:disabled {
      background: #d4d4d4;
      border-color: #d4d4d4;
      border-radius: 2px;
    }
  `;

  const { name, email } = values;

  let customerInputs = (
    <>
      <FlexRow>
        <FlexBaseCol>
          <InputField name="name" validate={validation(isRequired)} />
        </FlexBaseCol>
      </FlexRow>
      <FlexRow>
        <FlexBaseCol>
          <StyledDisabledField name="email" disabled />
          <HiddenField name="email" />
        </FlexBaseCol>
      </FlexRow>
      <FlexRow>
        <FlexBaseCol>
          <InputField name="phone" validate={validation(isRequired, isPhoneNumber)} />
        </FlexBaseCol>
      </FlexRow>
    </>
  );

  if (directCustomer) {
    customerInputs = <HiddenField name="email" />;
  }

  return (
    <Form
      initialValues={{
        name,
        email
      }}
      onSubmit={formData => {
        onInfoFormSubmit();
        setValues({ ...values, ...formData });
      }}
      render={({ handleSubmit, pristine, invalid }) => (
        <form
          action={window.env.LEAD_FORM_ACTION}
          method={window.env.LEAD_FORM_METHOD}
          onSubmit={e => {
            e.preventDefault();
            handleSubmit();
            e.target.submit();
          }}
        >
          <Grid>
            {customerInputs}
            <FlexRow>
              <FlexBaseCol>
                <SelectField
                  name="team size"
                  label="Size of your content team"
                  options={teamSizes}
                  validate={validation(isRequired)}
                />
              </FlexBaseCol>
            </FlexRow>
            <FlexRow>
              <FlexBaseCol>
                <SelectField
                  name="priorities"
                  label="Content priority"
                  options={contentPriorities}
                  validate={validation(isRequired)}
                />
              </FlexBaseCol>
            </FlexRow>
            <FlexRow>
              <StyledButtonCol margin={{ vertical: 'small' }}>
                <StyledButton type="submit" variant="secondary" disabled={pristine || invalid}>
                  Show me more freelancers
                  <Icon type="angle-right" />
                </StyledButton>
              </StyledButtonCol>
            </FlexRow>
          </Grid>
        </form>
      )}
    />
  );
};

AdditionalInfoForm.propTypes = {
  onInfoFormSubmit: PropTypes.func.isRequired
};

export default AdditionalInfoForm;
